/**
 * @file Attribute Data 归因数据
 */
import {
  integerValueFormatter,
  moneyFormatterWithUnit,
} from 'src/const/statistics/formatters';
import store from 'src/store';

const isDedicatedCampaign = () => !store.getters['dashboard/isDedicatedCampaignExist'];

export const EnumAttributionSkanData = [
  {
    i18nPath: 'common_skan_convert_cnt_show', // VTA Conversion (SKAN)
    hint: 'campaign_hover_stat_data.skan_convert_cnt_show',
    key: 'skan_convert_cnt_show',
    sortable: true,
    formatter: integerValueFormatter,
    hide: isDedicatedCampaign,
  },
  {
    i18nPath: 'common_skan_convert_cnt_show_cost', // Cost per VTA Conversion (SKAN)
    hint: 'campaign_hover_stat_data.skan_convert_cnt_show_cost',
    key: 'skan_convert_cnt_show_cost',
    sortable: true,
    formatter: moneyFormatterWithUnit,
    hide: isDedicatedCampaign,
  },
  {
    i18nPath: 'common_skan_active_show', // VTA App Install (SKAN)
    hint: 'campaign_hover_stat_data.skan_active_show',
    key: 'skan_active_show',
    sortable: true,
    formatter: integerValueFormatter,
    hide: isDedicatedCampaign,
  },
  {
    i18nPath: 'common_skan_active_show_cost', // Cost per VTA App Install (SKAN)
    hint: 'campaign_hover_stat_data.skan_active_show_cost',
    key: 'skan_active_show_cost',
    sortable: true,
    formatter: moneyFormatterWithUnit,
    hide: isDedicatedCampaign,
  },
  {
    i18nPath: 'common_skan_active_register_show', // VTA Registration (SKAN)
    hint: 'campaign_hover_stat_data.skan_active_register_show',
    key: 'skan_active_register_show',
    sortable: true,
    formatter: integerValueFormatter,
    hide: isDedicatedCampaign,
  },
  {
    i18nPath: 'common_skan_active_register_show_cost', // Cost per VTA Registration (SKAN)
    hint: 'campaign_hover_stat_data.skan_active_register_show_cost',
    key: 'skan_active_register_show_cost',
    sortable: true,
    formatter: moneyFormatterWithUnit,
    hide: isDedicatedCampaign,
  },
  {
    i18nPath: 'common_skan_active_pay_show', // VTA Purchase (SKAN)
    hint: 'campaign_hover_stat_data.skan_active_pay_show',
    key: 'skan_active_pay_show',
    sortable: true,
    formatter: integerValueFormatter,
    hide: isDedicatedCampaign,
  },
  {
    i18nPath: 'common_skan_active_pay_show_cost', // Cost per VTA Purchase (SKAN)
    hint: 'campaign_hover_stat_data.skan_active_pay_show_cost',
    key: 'skan_active_pay_show_cost',
    sortable: true,
    formatter: moneyFormatterWithUnit,
    hide: isDedicatedCampaign,
  },
  {
    i18nPath: 'common_skan_convert_cnt_click', // CTA Conversion (SKAN)
    hint: 'campaign_hover_stat_data.skan_convert_cnt_click',
    key: 'skan_convert_cnt_click',
    sortable: true,
    formatter: integerValueFormatter,
    hide: isDedicatedCampaign,
  },
  {
    i18nPath: 'common_skan_convert_cnt_click_cost', // Cost per CTA Conversion (SKAN)
    hint: 'campaign_hover_stat_data.skan_convert_cnt_click_cost',
    key: 'skan_convert_cnt_click_cost',
    sortable: true,
    formatter: moneyFormatterWithUnit,
    hide: isDedicatedCampaign,
  },
  {
    i18nPath: 'common_skan_active_click', // CTA App Install (SKAN)
    hint: 'campaign_hover_stat_data.skan_active_click',
    key: 'skan_active_click',
    sortable: true,
    formatter: integerValueFormatter,
    hide: isDedicatedCampaign,
  },
  {
    i18nPath: 'common_skan_active_click_cost', // Cost per CTA App Install (SKAN)
    hint: 'campaign_hover_stat_data.skan_active_click_cost',
    key: 'skan_active_click_cost',
    sortable: true,
    formatter: moneyFormatterWithUnit,
    hide: isDedicatedCampaign,
  },
  {
    i18nPath: 'common_skan_active_register_click', // CTA Registration (SKAN)
    hint: 'campaign_hover_stat_data.skan_active_register_click',
    key: 'skan_active_register_click',
    sortable: true,
    formatter: integerValueFormatter,
    hide: isDedicatedCampaign,
  },
  {
    i18nPath: 'common_skan_active_register_click_cost', // Cost per CTA Registration (SKAN)
    hint: 'campaign_hover_stat_data.skan_active_register_click_cost',
    key: 'skan_active_register_click_cost',
    sortable: true,
    formatter: moneyFormatterWithUnit,
    hide: isDedicatedCampaign,
  },
  {
    i18nPath: 'common_skan_active_pay_click', // CTA Purchase (SKAN)
    hint: 'campaign_hover_stat_data.skan_active_pay_click',
    key: 'skan_active_pay_click',
    sortable: true,
    formatter: integerValueFormatter,
    hide: isDedicatedCampaign,
  },
  {
    i18nPath: 'common_skan_active_pay_click_cost', // Cost per CTA Purchase (SKAN)
    hint: 'campaign_hover_stat_data.skan_active_pay_click_cost',
    key: 'skan_active_pay_click_cost',
    sortable: true,
    formatter: moneyFormatterWithUnit,
    hide: isDedicatedCampaign,
  },
];


export const EnumAttributionNonSkanData = [
  {
    i18nPath: 'common_convert_cnt_show', // VTA Conversion
    key: 'time_attr_convert_cnt_show',
    sortable: true,
    hint: 'campaign_hover_stat_data.convert_cnt_show',
    formatter: integerValueFormatter,
  },
  {
    i18nPath: 'common_convert_cnt_show_cost', // 展示归因激活成本
    key: 'time_attr_convert_cnt_show_cost',
    sortable: true,
    hint: 'campaign_hover_stat_data.convert_cnt_show_cost',
    formatter: moneyFormatterWithUnit,
  },
  {
    i18nPath: 'common_active_show', // 展示归因激活数
    key: 'time_attr_active_show',
    sortable: true,
    hint: 'common_hint_attr_tooltip',
    formatter: integerValueFormatter,
  },
  {
    i18nPath: 'common_active_show_cost', // 展示归因激活成本
    key: 'time_attr_active_show_cost',
    sortable: true,
    hint: 'campaign_hover_stat_data.active_click_cost',
    formatter: moneyFormatterWithUnit,
  },
  {
    i18nPath: 'common_active_register_show', // 展示归因注册次数
    hint: 'campaign_hover_stat_data.active_register_click',
    key: 'time_attr_active_register_show',
    sortable: true,
    formatter: integerValueFormatter,
  },
  {
    i18nPath: 'common_active_register_show_cost', // 展示归因注册成本
    hint: 'campaign_hover_stat_data.active_register_show_cost',
    key: 'time_attr_active_register_show_cost',
    sortable: true,
    formatter: moneyFormatterWithUnit,
  },
  {
    i18nPath: 'common_active_pay_show', // 展示归因付费次数
    hint: 'campaign_hover_stat_data.active_pay_show',
    key: 'time_attr_active_pay_show',
    sortable: true,
    formatter: integerValueFormatter,
  },
  {
    i18nPath: 'common_active_pay_show_cost', // 展示归因付费成本
    hint: 'campaign_hover_stat_data.active_pay_show_cost',
    key: 'time_attr_active_pay_show_cost',
    sortable: true,
    formatter: moneyFormatterWithUnit,
  },
  {
    i18nPath: 'common_convert_cnt_click', // CTA Conversion
    hint: 'campaign_hover_stat_data.convert_cnt_click',
    key: 'time_attr_convert_cnt_click',
    sortable: true,
    formatter: integerValueFormatter,
  },
  {
    i18nPath: 'common_convert_cnt_click_cost', // Cost per CTA Conversion
    hint: 'campaign_hover_stat_data.convert_cnt_click_cost',
    key: 'time_attr_convert_cnt_click_cost',
    sortable: true,
    formatter: moneyFormatterWithUnit,
  },
  {
    i18nPath: 'common_active_click', // 点击归因激活数
    hint: 'campaign_hover_stat_data.active_click',
    key: 'time_attr_active_click',
    sortable: true,
    formatter: integerValueFormatter,
  },
  {
    i18nPath: 'common_active_click_cost', // 点击归因激活成本
    hint: 'campaign_hover_stat_data.active_click_cost',
    key: 'time_attr_active_click_cost',
    sortable: true,
    formatter: moneyFormatterWithUnit,
  },
  {
    i18nPath: 'common_active_register_click', // 点击归因注册次数
    hint: 'campaign_hover_stat_data.active_register_click',
    key: 'time_attr_active_register_click',
    sortable: true,
    formatter: integerValueFormatter,
  },
  {
    i18nPath: 'common_active_register_click_cost', // 点击归因注册成本
    hint: 'campaign_hover_stat_data.active_register_click_cost',
    key: 'time_attr_active_register_click_cost',
    sortable: true,
    formatter: moneyFormatterWithUnit,
  },
  {
    i18nPath: 'common_active_pay_click', // 点击归因付费次数
    hint: 'campaign_hover_stat_data.active_pay_click',
    key: 'time_attr_active_pay_click',
    sortable: true,
    formatter: integerValueFormatter,
  },
  {
    i18nPath: 'common_active_pay_click_cost', // 点击归因付费成本
    hint: 'campaign_hover_stat_data.active_pay_click_cost',
    key: 'time_attr_active_pay_click_cost',
    sortable: true,
    formatter: moneyFormatterWithUnit,
  },
];

export const EnumAttributionData = EnumAttributionNonSkanData.concat(EnumAttributionSkanData);
